import { LanguageUtils, SupportedLanguage } from '@foundation/localization';
import { useTranslation } from '@shared/localization';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TranslationIcon } from '@/components/common/icons';
import TelemetryService from '@/services/telemetry/TelemetryService';
import { TelemetryEvent } from '@/telemetry';

export function LanguageSelector() {
  const {
    i18n,
    i18n: { language },
  } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const onLanguageUpdate = (newLocale?: string | null) => {
    if (newLocale === void 0 || newLocale === null || newLocale === language) {
      return;
    }

    i18n.changeLanguage(newLocale).then(() => {
      TelemetryService.trackEvent({
        name: TelemetryEvent.LanguageUpdated,
        properties: {
          locale: newLocale,
        },
      });
    });
  };

  useEffect(() => {
    if (searchParams.has('locale')) {
      searchParams.set('locale', language);
    } else {
      searchParams.append('locale', language);
    }
    setSearchParams(searchParams);
  }, [language, searchParams, setSearchParams]);

  return (
    <div className="flex relative focused-container">
      <TranslationIcon className="self-center inline-block w-6" />
      <span className='ml-xs after:content-[""] after:ml-xs after:border-4 after:border-transparent after:border-t-inherit after:absolute after:top-1/2 after:-translate-y-0.5'>
        {LanguageUtils.name(language as SupportedLanguage)}
      </span>
      {/* Hide the select element so that the text width is dynamic with the content */}
      <select
        className="absolute w-full h-full inset-0 appearance-none cursor-pointer opacity-0"
        title="Language selector"
        onChange={(event) => onLanguageUpdate(event?.target.value)}
        defaultValue={language}
      >
        {Object.values(SupportedLanguage).map((l) => (
          <option
            key={l}
            value={l}
          >
            {LanguageUtils.name(l)}
          </option>
        ))}
      </select>
    </div>
  );
}
